module.exports = __webpack_public_path__ + "media/images/city/020-temple-of-heaven-d3a739b843fb3a9319ce983221eed898.svg";